import "./Services.module.css";
import Benefits from "./sections/Benefits";
import Contact from "./sections/Contact";
export default function ServicesPage() {
  return <div>
      <Benefits />
      <Contact />
    </div>;
}